_ = require 'underscore'
BoardListItemComponent = require 'views/board-list/board-list-item-component'
BoardListItemAddComponent = require 'views/board-list/board-list-item-add-component'
BoardListItemTagComponent = require 'views/board-list/board-list-item-tag-component'
BoardListSectionComponent = require 'views/board-list/board-list-section-component'
OrganizationBoardsFilterComponent = require 'views/organization/organization-boards-filter-component'
React = require 'react'
Util = require 'lib/util'
t = require('views/internal/recup-with-helpers')('org_filtering')
l = require 'lib/localize'
f = require 'effing'
formatNumber = require 'lib/format/number'
naiveShouldComponentUpdate = require 'lib/util/naive-should-component-update'
xtend = require 'xtend'
track = require 'debug/track'

sortOptions = ['active', 'members', 'stars', 'alphabetical']
publicStateProperties = ['tagFilter', 'sort']

module.exports = class extends React.Component
  displayName: 'OrganizationBoardsComponent'

  constructor: (props) ->
    super(props)

    initialState = _.defaults @props.initialFilterState ? {},
      filter: ''
      tagFilter: null
      sort: sortOptions[0]
      showOtherPrivateBoards: false

    if @filterDoesntExist(initialState.tagFilter, @props.tags)
      initialState.tagFilter = null

    @state = initialState

  render: t.renderable ->
    t.div '.boards-page-layout', =>
      t.div '.boards-page-layout-sidebar', =>
        t.addElement @getFilterComponent()
      t.div '.boards-page-layout-list', =>
        t.addElement @getBoardsComponent()

  componentWillReceiveProps: (nextProps) ->
    if @filterDoesntExist(@state.tagFilter, nextProps.tags)
      @setState tagFilter: null

  componentWillUpdate: (nextProps, nextState) ->
    if !_.isEqual(_.pick(nextState, publicStateProperties), _.pick(@state, publicStateProperties))
      @props.onFilterChange(_.pick(nextState, publicStateProperties))

  shouldComponentUpdate: naiveShouldComponentUpdate

  filterDoesntExist: (filter, tags) -> filter && !(filter in _.pluck(tags, 'id'))

  toggleTagFilter: (tagFilter) ->
    if tagFilter == @state.tagFilter
      @setState tagFilter: null
    else
      @setState { tagFilter }

  toggleShowOtherPrivateBoards: ->
    @setState showOtherPrivateBoards: !@state.showOtherPrivateBoards

  isVisibleBoard: (board) ->
    (!@state.tagFilter || @state.tagFilter in board.idTags) &&
    (!@state.filter || Util.buildFuzzyMatcher(@state.filter)(board.name)) &&
    (@state.showOtherPrivateBoards || !board.isOtherPrivate)

  getBoardsComponent: ->
    props =
      items:
        _.chain @props.boards.slice().sort (a, b) ->
          a.name.localeCompare(b.name)
        .sortBy (board) =>
          switch @state.sort
            when 'alphabetical'
              # It is already sorted alphabetically and sortBy is stable
              0
            when 'active'
              -board.dateLastActivity.valueOf()
            when 'members'
              -board.membershipCount
            when 'stars'
              -board.starCount
        .map (board) =>
          xtend board,
            hidden: !@isVisibleBoard(board)
            tagComponents: board.tags.map (tag) =>
              React.createElement BoardListItemTagComponent,
                text: tag.name
                key: tag.id
                selected: tag.id == @state.tagFilter
                onClick: =>
                  track("Organization View", "Boards Page", "Click Tag Under Board")
                  @toggleTagFilter tag.id
            .concat(board.extraTagComponents)
        .map (boardModel) ->
          React.createElement(BoardListItemComponent, boardModel)
        .value()
      createNewItem:
        if @props.newBoard?
          React.createElement BoardListItemAddComponent,
            newBoard: @props.newBoard
            preloadData: @props.preloadCreateBoardData

    React.createElement BoardListSectionComponent, props

  getFilterComponent: ->
    countByMultiple = (list, iteratee) ->
      obj = {}
      for item in list
        for group in iteratee(item)
          if !Object.hasOwnProperty.call(obj, group)
            obj[group] = 0
          obj[group]++
      obj
    counts = countByMultiple @props.boards, f.get('idTags')

    props =
      tags: @props.tags.map (tag) =>
        html: t.l 'tag-with-count', name: tag.name, count: formatNumber(counts[tag.id] ? 0)
        onClick: @toggleTagFilter.bind(@, tag.id)
        selected: tag.id == @state.tagFilter
      sorts: sortOptions.map (key) =>
        html: l ['org sort', key]
        onClick: =>
          track("Organization View", "Boards Page", "Select Sort", key)
          @setState sort: key
        selected: key == @state.sort
      onFilterChange: (filter) =>
        @setState { filter }
      onAddTag: @props.addTag
      filter: @state.filter
      showOtherPrivateBoards: @state.showOtherPrivateBoards
      canShowOtherPrivateBoards: _.find @props.boards, 'isOtherPrivate'
      toggleOtherPrivateBoards: f(@, 'toggleShowOtherPrivateBoards')
      key: @id
      isGhost: @props.isGhost

    React.createElement(OrganizationBoardsFilterComponent, props)



// WEBPACK FOOTER //
// ./app/scripts/views/organization/organization-boards-component.coffee